import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Spinner from "../../components/uxCollections/Loaders";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../../slice/webStoreUserSlice";

const VerifyEmail = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const { user } = useSelector((state) => state.webStoreUser);
  const dispatch = useDispatch();
  useEffect(() => {
    verifyEmailFunc();
    console.log(id);
  }, []);

  const verifyEmailFunc = async () => {
    try {
      let response = await fetch(`${process.env.REACT_APP_Back_end_api_root}/verifyEmail/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          //Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      if (response.ok) {
        // check if the user is set on the redux store
        let updateUser = await response.json();
        if (updateUser._id.toString() === user._id.toString()) {
          // update the user in the redux store
          console.log("User is already set in the store, no need to update");

          dispatch(setUser(updateUser));
        }
        setIsLoading(false);
      } else {
        console.log("Email verification failed");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {isLoading ? (
        <Spinner position={"fixed"} backgroundColor='white' />
      ) : (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh" }}>
          {/* <img src={require("../../assetsStatic/success.png")} /> */}
          {/* Icon for checked */}
          <img
            src='https://socialapps.tech/sites/default/files/nodeicon/plugins_email-verification-plugin.png'
            alt='success'
            style={{ width: "100px", height: "100px" }}
          />
          <h2 style={{ marginTop: "12px" }}>Email verified successfully</h2>
        </div>
      )}
    </>
  );
};

export default VerifyEmail;
